import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from "react"

import { OverlaidAnimationStyle } from "./types"

interface AnimationState {
  overlaidAnimation: OverlaidAnimationStyle | null
  setOverlaidAnimation: Dispatch<
    SetStateAction<OverlaidAnimationStyle | null>
  >
  thankYouAnimationFirstName: string | null
  setThankYouAnimationFirstName: Dispatch<SetStateAction<string | null>>
}

export const AnimationContext = createContext<AnimationState | undefined>(
  undefined,
)

type AnimationProviderProps = {
  children: ReactNode
}

const AnimationProvider = ({ children }: AnimationProviderProps) => {
  const [overlaidAnimation, setOverlaidAnimation] =
    useState<OverlaidAnimationStyle | null>(null)
  const [thankYouAnimationFirstName, setThankYouAnimationFirstName] =
    useState<string | null>(null)

  // Assemble the state to return.
  // This is what everyone who uses `useAnimationContext` will receive
  const state: AnimationState = {
    overlaidAnimation,
    setOverlaidAnimation,
    thankYouAnimationFirstName,
    setThankYouAnimationFirstName,
  }

  return (
    <AnimationContext.Provider value={state}>
      {children}
    </AnimationContext.Provider>
  )
}

const useAnimationContext = () => {
  const animationContext = useContext(AnimationContext)
  if (!animationContext) {
    throw new Error(
      "No AnimationContext.Provider found when calling useAnimationContext.",
    )
  }
  return animationContext
}

export { AnimationProvider, useAnimationContext }
